import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/users')({
  staticData: { crumb: 'users' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'users.read'),
  component: Outlet,
})
